module.exports = __webpack_public_path__ + "img/44.6924e419.jpg";